"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seq = void 0;
var seq = function (length) {
    return new Array(length).fill(0).map(function (_, i) { return i; });
};
exports.seq = seq;
